export const getTelemetryConfig = ($shipBobStore) => {
  return {
    isMFETelementryEnabled: $shipBobStore?.getters.isMFETelemetryEnabled,
    host: 'MerchantApp'
  }
}
